module.exports = __webpack_public_path__ + "img/develop.4c9ecf99.png";